import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowDropUpIcon from '@material-ui/icons/ArrowDropUp';
import HistoryIcon from '@material-ui/icons/History';
import GroupOutlinedIcon from '@material-ui/icons/GroupOutlined';
import ListOutlinedIcon from '@material-ui/icons/ListOutlined';
import StoreOutlinedIcon from '@material-ui/icons/StoreOutlined';
import LocalMallOutlinedIcon from '@material-ui/icons/LocalMallOutlined';
import BallotOutlinedIcon from '@material-ui/icons/BallotOutlined';
import LocalAtmOutlinedIcon from '@material-ui/icons/LocalAtmOutlined';
import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import RecordVoiceOverOutlinedIcon from '@material-ui/icons/RecordVoiceOverOutlined';
import AssessmentOutlinedIcon from '@material-ui/icons/AssessmentOutlined';
import SupervisorAccountOutlinedIcon from '@material-ui/icons/SupervisorAccountOutlined';
import ViewModuleOutlinedIcon from '@material-ui/icons/ViewModuleOutlined';
import PaymentOutlinedIcon from '@material-ui/icons/PaymentOutlined';
import EqualizerOutlinedIcon from '@material-ui/icons/EqualizerOutlined';
import AssignmentIndOutlinedIcon from '@material-ui/icons/AssignmentIndOutlined';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';
import DeveloperBoardOutlinedIcon from '@material-ui/icons/DeveloperBoardOutlined';
import SupervisedUserCircleOutlinedIcon from '@material-ui/icons/SupervisedUserCircleOutlined';
import ForumOutlinedIcon from '@material-ui/icons/ForumOutlined';
import BlurLinearOutlinedIcon from '@material-ui/icons/BlurLinearOutlined';

export default {
    ArrowDropDownIcon,
    ArrowDropUpIcon,
    HistoryIcon,
    GroupOutlinedIcon,
    ListOutlinedIcon,
    StoreOutlinedIcon,
    LocalMallOutlinedIcon,
    BallotOutlinedIcon,
    LocalAtmOutlinedIcon,
    RecordVoiceOverOutlinedIcon,
    SettingsOutlinedIcon,
    AssessmentOutlinedIcon,
    SupervisorAccountOutlinedIcon,
    ViewModuleOutlinedIcon,
    PaymentOutlinedIcon,
    EqualizerOutlinedIcon,
    AssignmentIndOutlinedIcon,
    ExitToAppOutlinedIcon,
    DeveloperBoardOutlinedIcon,
    SupervisedUserCircleOutlinedIcon,
    ForumOutlinedIcon,
    BlurLinearOutlinedIcon
}
